export const PUBLICURL = window.location.protocol + '//' + window.location.host + '/';
export const showZzToast = 10;//打开自助查询弹窗的秒数
//本地配置
// export const host = '';//请求连接

//线上配置
export const host = 'https://api.zhpwxt.com';//请求连接






const imageCoversion = require("image-conversion");
import store from '../store'

import { post, get } from "./https"

export function checkPrinterStatus() {
    //  new Promise((resolve, reject) => {
    get('/api/v1/window/printerStatus').then(res => {
        return res.status
    })

}

export function getStatusName(s) {
    return s == 0 ? '待支付' : s == 1 ? '支付成功' : s == 2 ? '部分退款' : s == 3 ? '全部退款' : s == 9 ? '支付失败' : ''
}
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}
//校验显示的字符串
export function stringCheck(str) {
    if (str) {
        return str;
    } else {
        return '';
    }
}
/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()
    const diff = (now - d) / 1000;
    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        )
    }
}
/**
 * 获取地址栏携带的参数值
 * @param {string} string
 * @returns {string}
 */
export function getQueryString(variable) {
    let herf = window.location.href;
    let num = herf.indexOf("?") + 1;
    let query = herf.substring(num);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return false;
}
/**
 * 设置题目控件的显隐
 * t=1 隐藏 0显示
 */
export function qContorlDisplay(t) {
    store.dispatch("menuTree/setLeftBarActive", t);
}

export function randomString(e) {
    e = e || 32;
    var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
        a = t.length,
        n = "";
    for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
    return n + '_' + new Date().getTime()
}
/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
        return {}
    }
    return JSON.parse(
        '{"' +
        decodeURIComponent(search)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"')
            .replace(/\+/g, ' ') +
        '"}'
    )
}

//上传图片
export function uploadimg(file) {
    return new Promise((resolve, reject) => {
        imageCoversion
            .compressAccurately(file, 500)
            .then((res1) => {
                resolve(res1)
            })
            .catch((res) => {
                reject()
                // console.log(res);
                Toast("上传失败，请稍后重试");
            });
    })
}
//获取产品问卷的key值
export function getProKey(data) {
    let key = data == 0 ? 'head' : data == 1 ? 'product' : 'foot'
    return key;
}

// 设置cookie
export function setCookie(cname, cvalue) {
    var d = new Date();
    d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}
// 获取cookie
export function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
//深拷贝
export function deepCopy(data) {
    return JSON.parse(JSON.stringify(data))
}
//获取是产品还是甄别  return 0-甄别 1-产品
export function getPageName() {
    // let n = getQueryString('pageName');
    return 1;
}

//获取问卷的ID
export function getProductId() {
    let id = getQueryString('id');
    return id;
}
//socket心跳
export function heartbeat(socket) {
    let sendData = {
        action: "heartbeat",
    }
    return setInterval(() => {
        socket.send(JSON.stringify(sendData))
    }, 60000);
}

//获取设备类型
export function getMtype() {
    var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet =
            /(?:iPad|PlayBook)/.test(ua) ||
            (isAndroid && !/(?:Mobile)/.test(ua)) ||
            (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
    let os = {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
    };
    if (os.isTablet) {
        // 平板
        return 'pc'
    } else if (os.isAndroid || os.isPhone) {
        // 手机
        return 'mob'
    } else if (os.isPc) {
        // pc
        if (document.body.clientWidth < 768) {
            //小屏
            return 'mob'
        } else {
            //大屏
            return 'pc'
        }
    }
}



